module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-13 at 03.56.31.6d77952c.png";